import { Box, Button, LinearProgress, Typography } from '@material-ui/core';
import CustomSlider from 'components/CustomSlider';
import Interweave from 'interweave';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';

/**
 *
 * @param {[{banner:string name:string description:string description:string liked_course:boolean id_company_course:string assigned: boolean}]} courses
 * @param {(id_company_course: string)=> {}} onLike
 * @param {(id: string)=> {}} onActionClick
 */
const ProgressAcademyIASlider = ({
  courses,
  onLike,
  onActionClick,
  academy,
  slidesNumber,
  finished,
  ...props
}) => {
  const { t } = useTranslation(['button']);
  const [slidesToShow, setSlidesToShow] = React.useState(4);
  const classes = useStyles();

  const toFixed = (num, fixed) => {
    fixed = fixed || 0;
    fixed = Math.pow(10, fixed);
    return Math.floor(num * fixed) / fixed;
  };
  
  return (
    <CustomSlider
      itens={courses}
      slidesNumber={slidesNumber}
      slidesToShow={slidesToShow}
      setSlidesToShow={setSlidesToShow}
      slideTeste={true}
      {...props}
    >
      {courses?.map((course, index) => {
        return (
          <div className={classes.slidesShow}>
            <Box
              className={classes.card}
              style={{ width: slidesToShow <= 2 ? 350 : 'unset' }}
            >
              <Box>
                <Link
                  onClick={() => {
                    if (onActionClick) {
                      onActionClick(course?.id);
                    }
                  }}
                >
                  <img
                    className={classes.media}
                    src={
                      course.card.url
                        ? course.card.url
                        : 'https://placehold.co/350x208/1593CB/FFFFFF/png'
                    }
                  />
                </Link>
                <Box className={classes.cardBody}>
                  <Typography component="span" className={classes.header}>
                    {course.name}
                  </Typography>
                  <Box className={classes.description}>
                    <Interweave
                      content={
                        course?.description?.length ? course?.description : '-'
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        );
      })}
    </CustomSlider>
  );
};
export default ProgressAcademyIASlider;
